const base = process.env.PUBLIC_URL || '';

export function UmbLogo({ className = 'h-[34px] w-[107px]', alt = 'UMB' }) {
  return (
    <img
      src={`${base}/branding/umb-logo.png`}
      alt={alt}
      width={107}
      height={34}
      className={`object-contain object-left ${className}`}
    />
  );
}
